<template>
  <el-dialog v-dialogDrag width="400px" :title="title" :visible.sync="dlgVisible">
    <div>
      <div>请输入目录ID：</div>
      <el-input v-model="folderId" placeholder="" size="small"></el-input>
      <div>空值则表示取消设置</div>
    </div>
    <template #footer>
      <el-button size="small" @click="dlgVisible = false">关闭</el-button>
      <el-button type="primary" size="small" @click="handleOK">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      title: "选择目录",
      dlgVisible: false,
      folderId: ""
    };
  },
  methods: {
    showDlg(folderId, title) {
      this.folderId = folderId || "";
      if (title) {
        this.title = title;
      }
      this.dlgVisible = true;
    },
    async handleOK() {
      await this.$emit("ok", this.folderId);
      this.dlgVisible = false;
    }
  }
};
</script>

<style>
</style>
